import * as React from "react";

function SvgSlant2Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1610 160v53.2H-10V160L800 41.1 1610 160z" /></svg>;
}

export default SvgSlant2Inverted;